export default "__VITE_ASSET__BHTVCpk0__"